export default __webpack_public_path__ + "static/media/CTP_Dark_IT.4cffb093.svg";